module.exports = Backbone.Model.extend({
  url: function () {
    return this.baseUrl + (this.id ? 'contents/' + this.id : 'contents');
  }
});
